export const API_URL = import.meta.env.VITE_PUBLIC_API_URL ?? '';
